module.exports = __webpack_public_path__ + "static/media/7-9.2d2399eb.mp3";